import { render, staticRenderFns } from "./CoupassTabsView.vue?vue&type=template&id=53efb3ea&scoped=true"
import script from "./CoupassTabsView.vue?vue&type=script&lang=js"
export * from "./CoupassTabsView.vue?vue&type=script&lang=js"
import style0 from "./CoupassTabsView.vue?vue&type=style&index=0&id=53efb3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53efb3ea",
  null
  
)

export default component.exports